import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=c3d6e9a0&"
import script from "./spec.vue?vue&type=script&lang=js&"
export * from "./spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports